import {
  BrainAssertionLoadState,
  resolveBrainAssertionLoadState,
} from './brainAssertionLoadState';
import type { BrainAssertionView } from '../../../models/companyBrain';
import { useBrainAssertionQuery } from '../../../services/companyBrain.service';

interface UseBrainAssertionParams {
  teamId: string;
  assertionId: string;
  skip?: boolean;
}

interface UseBrainAssertionResult {
  assertion: BrainAssertionView | null;
  loadState: BrainAssertionLoadState;
}

export function useBrainAssertion({
  teamId,
  assertionId,
  skip = false,
}: UseBrainAssertionParams): UseBrainAssertionResult {
  const { data, loading, error } = useBrainAssertionQuery({
    teamId,
    assertionId,
    skip,
  });
  const assertion = data?.brainAssertion ?? null;

  return {
    assertion,
    loadState: resolveBrainAssertionLoadState({
      loading,
      error,
      assertion,
      hasIds: Boolean(teamId && assertionId) && !skip,
    }),
  };
}
